import { Row, Col, Skeleton } from "antd";
import PlanCardSkeleton from "./PlanCardSkeleton";

const PlansPageSkeleton = () => {
  return (
    <Row gutter={[40, 40]} justify="center" align="middle">
      <Col span={24} style={{ textAlign: "center" }}>
        <Skeleton
          active
          title={{
            style: {
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "10rem",
              margin: "0 auto",
            },
          }}
          paragraph={{
            rows: 0,
          }}
        />
        <Skeleton
          active
          title={{
            width: "100%",
            style: {
              fontSize: "2.5rem",
              height: "80px",
            },
          }}
          paragraph={false}
        />
      </Col>
      <Col span={24} style={{ textAlign: "center" }}>
      <Row gutter={[40, 40]} justify="start" align="middle">
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <Col key={index} style={{ marginBottom: 20 }} xs={24} sm={12} md={12} lg={8}>
            <PlanCardSkeleton />
          </Col>
        ))}
        </Row>
      </Col>
      <Col span={24} style={{ textAlign: "center" }}>
        <Skeleton.Button
          active
          style={{ width: 250, height: 36 }}
        ></Skeleton.Button>
      </Col>
    </Row>
  );
};

export default PlansPageSkeleton;
